export const header = () => {
    const burger = document.querySelector('.header__burger')
    const mobileMenu = document.querySelector('.mobile-menu')


    burger.addEventListener('click', () => {
        burger.classList.toggle('active')
        mobileMenu.classList.toggle('active')
    })





    jQuery(document).ready(function ($) {

        $('.header__right-search-icon').each(function (index) {
            $(this).on('click', () => {
                $('.header__search-container').eq(index).toggleClass('active')
                if ($('.header__search-container').eq(index).hasClass('active')) {
                    $('.header__search').eq(index).slideDown()
                } else {
                    $('.header__search').eq(index).slideUp()
                }
            })
        })

    });





}